export default __webpack_public_path__ + "static/Propertymark_CMP_Main_Scheme_Certificate2026-81a30a1f5afca1f4d06cf735ebb71080.pdf";